import api from '@api'

import {
  getRootTranslator,
  getRootPluaralTranslator,
} from '@utils/get-module-translator'

export function transformQuantity(quantity) {
  return {
    id: quantity.id,
    quantity: quantity.quantity,
    purchaseDate: quantity.purchaseDate,
    currencyId: quantity.currencyId,
    purchaseCost: quantity.purchaseCost,
    expiryDate: quantity.expiryDate,
    vendorId: quantity.vendorId,
    barCode: quantity.barCode,
    fileAttachments: quantity.fileAttachments,
    description: quantity.description,
    createdBy: quantity.createdById,
    createdAt: quantity.createdTime,
    updatedAt: quantity.updatedTime,
    canDelete: quantity.deleteableOob,
    canEdit: quantity.updatebleOob,
  }
}

export function transformQuantityForServer(quantity) {
  return {
    quantity: quantity.quantity,
    purchaseDate: quantity.purchaseDate,
    currencyId: quantity.currencyId,
    purchaseCost: quantity.purchaseCost,
    expiryDate: quantity.expiryDate,
    vendorId: quantity.vendorId,
    barCode: quantity.barCode,
    fileAttachments: quantity.fileAttachments,
    description: quantity.description,
  }
}

const __rootT = getRootTranslator()
const __rootTc = getRootPluaralTranslator()

export function getQuantitiesApi(assetId, limit, offset) {
  return api
    .get(`/asset_consumable/${assetId}/quantity`, {
      params: {
        offset: offset || 0,
        size: limit === undefined ? 1000 : limit,
      },
      notify: false,
    })
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformQuantity),
        total: data.totalCount,
      }
    })
}

export function createQuantityApi(assetId, data) {
  return api
    .post(
      `/asset_consumable/${assetId}/quantity`,
      transformQuantityForServer(data),
      {
        message: __rootT('added_successfully', {
          resource: __rootTc('quantity'),
        }),
      }
    )
    .then(transformQuantity)
}

export function updateQuantityApi(assetId, data) {
  return api
    .patch(
      `/asset_consumable/${assetId}/quantity/${data.id}`,
      transformQuantityForServer(data),
      {
        message: __rootT('updated_successfully', {
          resource: __rootTc('quantity'),
        }),
      }
    )
    .then(transformQuantity)
}

export function bulkDeleteApi(assetId, ids) {
  return api.delete(
    `/asset_consumable/${assetId}/quantity/bulk/delete`,
    {
      data: { objectIds: ids },
    },
    {
      message: __rootT('deleted_successfully', {
        resource: __rootTc('quantity'),
      }),
    }
  )
}
